"use client"

import { useState } from "react"
import "./GreentechFaq.css"

const faqData = [
  {
    question: "What is Green technology?",
    answer:
      "Green technology, or green tech refers to the use of technology and science to create products, services, and processes that are environmentally friendly. It aims to minimize harm to the environment, reduce energy consumption, and promote sustainability",
  },
  {
    question: "What is difference between clean and green tech?",
    answer:
      "Green technology focuses on developing environmentally friendly innovations, while clean technology (or clean tech) is a broader term that encompasses products and services that reduce environmental impact. Clean tech includes renewable energy, waste management, energy efficiency, and more.",
  },
  {
    question: "Why is greentech important?",
    answer:
      "Green tech is crucial for mitigating climate change, reducing carbon emissions, and conserving natural resources. It promotes sustainable practices, which helps preserve the environment for future generations and can drive economic growth by creating green jobs and industries",
  },
  {
    question:
      "What are some examples of greentech in software development?",
    answer:
      "Green technology in software development involves creating software that minimizes energy consumption and reduces the environmental footprint of digital systems. Here are some examples of how green technology is applied in software development‍• Energy-efficient algorithms: Energy-efficient algorithms are designed to use computational resources more effectively, reducing CPU cycles and power consumption. These algorithms are often used in large-scale data processing and cloud computing to minimize energy use.• Low-power code optimization: Software developers can optimize code to reduce power usage, particularly on mobile devices where battery life is critical. Techniques include minimizing unnecessary operations, optimizing loops, and reducing memory usage.• Virtualization and containerization: Virtualization and containerization reduce hardware requirements by allowing multiple virtual environments to run on a single physical machine. This approach reduces energy consumption by consolidating resources and reducing the need for additional hardware.• Serverless computing: Serverless computing enables developers to run code without managing servers, which can lead to more efficient resource usage. This on-demand approach ensures that resources are only used when needed, reducing idle time and energy waste.• Cloud-based development: Cloud-based development tools and services allow developers to use shared resources, which can be more energy-efficient than dedicated hardware. Cloud providers often invest in green infrastructure, including renewable energy sources and energy-efficient data centers• Energy-efficient data centers: Many technology companies are building energy-efficient data centers that use renewable energy sources and advanced cooling systems. Software developers can contribute by designing applications that make efficient use of these data centers.• Sustainable DevOps practices: DevOps practices can be optimized for sustainability by automating processes to reduce resource usage. This includes automated scaling, continuous integration/continuous deployment (CI/CD) pipelines that minimize idle resources, and automated testing that reduces redundancy• Green software design principles: Green software design involves creating applications that require less processing power, use fewer resources, and have a longer lifespan. This can include designing applications to work on older hardware, minimizing network traffic, and using lightweight frameworks• Code reusability and open source: Encouraging code reusability and contributing to open source projects can reduce the need for duplicate development efforts. This approach promotes collaboration and minimizes waste in software development• Green coding practices: Green coding practices include choosing energy-efficient programming languages, using efficient data structures, and minimizing unnecessary computations. These practices contribute to overall energy efficiency in software development.",
  },
  
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section7724">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">GREEN TECHNOLOGY</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default FAQSection
